// styles.js
import styled from 'styled-components';

/* ----- Layout ----- */
export const Container = styled.div`
  max-width: 48rem; /* ~max-w-3xl */
  margin: 0 auto;
  padding: 1rem;

  @media (min-width: 640px) {
    padding: 1.5rem; /* sm:p-6 */
  }
`;

export const CenterSection = styled.div`
  text-align: center;
  padding-top: 3rem; /* py-12 */
  padding-bottom: 3rem;
`;

/* ----- Icon bubble (error) ----- */
export const ErrorIconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem auto; /* mx-auto mb-8 */
`;

/* ----- Headings & text ----- */
export const Title = styled.h1`
  margin: 0 0 1rem 0;
  color: #231f20;
  font-weight: 600;
  font-size: 32px;
`;

export const TextStack = styled.div`
  color: #231f20; 
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 2rem;
`;

export const Strong = styled.strong`
  font-weight: 600; /* font-semibold */
  margin: 0;
`;

/* ----- Card ----- */
export const Card = styled.div`
  background: #f1f5f7;
  border: 0;
  border-radius: 1rem; /* rounded-2xl */
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05); /* shadow-lg */
  padding: 1.25rem; /* ~p-5 */
  margin-bottom: 2rem; /* mb-8 */
`;

/* Office block */
export const OfficeRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem; /* gap-4 */
`;

export const OfficeIcon = styled.div`
  width: 3rem;
  height: 3rem; /* w-12 h-12 */
  background: #f3f4f6; /* gray-100 */
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const OfficeTitle = styled.h2`
  margin: 0 0 1rem 0; /* mb-4 */
  color: #111827; /* gray-900 */
  font-weight: 600; /* font-semibold */
  font-size: 1.25rem; /* text-xl */
`;

export const OfficeText = styled.div`
  color: #374151; /* gray-700 */
  display: grid;
  gap: 0.75rem; /* space-y-3 */
`;

export const SmallList = styled.div`
  display: grid;
  gap: 0.5rem; /* space-y-2 */
  font-size: 0.875rem; /* text-sm */
`;

/* Bring block */
export const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem; /* gap-3 */
`;

export const InfoDot = styled.div`
  width: 1.25rem;
  height: 1.25rem; /* w-5 h-5 */
  background: #4b5563; /* gray-600 */
  color: #ffffff;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.125rem; /* mt-0.5 */
  font-size: 0.75rem; /* text-xs */
  font-weight: 700; /* font-bold */
`;

export const InfoTitle = styled.h3`
  margin: 0 0 0.5rem 0; /* mb-2 */
  color: #111827; /* gray-900 */
  font-weight: 600; /* font-semibold */
`;

/* ----- Outline button (gray) ----- */
export const OutlineButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #ffffff;
  color: #374151; /* gray-700 */
  border: 1px solid #d1d5db; /* gray-300 */
  padding: 0.5rem 1.5rem; /* px-6 py-2 */
  border-radius: 0.5rem;
  cursor: pointer;

  &:hover {
    background: #f9fafb; /* gray-50 */
  }

  svg {
    width: 1rem;
    height: 1rem; /* w-4 h-4 */
  }
`;

export const BottomActions = styled.div`
  text-align: center;
`;
